<ul>
  <li
    *ngFor="
      let attachment of attachmentsInProgress;
      trackBy: trackByAttachmentProgress
    "
  >
    <app-attachments-uploading-list-item
      [attachment]="attachment"
      (onCancelAttachmentItem)="onCancelAttachment.emit($event)"
      (onRetryAttachmentItem)="onRetryAttachment.emit($event)"
    >
    </app-attachments-uploading-list-item>
  </li>
</ul>
